const state = {
    referrers: [],
    referrerGroups: [],
    exportingReferrers: false,
}

const getters = {
    getReferrers: (state) => {
        return state.referrers
    },
    getReferrerGroups: (state) => {
        return state.referrerGroups
    },
    getExportingReferrers: (state) => {
        return state.exportingReferrers
    },
};

const mutations = {
    setReferrerGroups(state, payload) {
        state.referrerGroups = payload
    },
    setReferrers(state, payload) {
        state.referrers = payload
    },
    setExportingReferrers(state, payload) {
        state.exportingReferrers = payload
    },
};

const actions = {
    setReferrers({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/referrers/get-referrers', payload, {
                headers: { Authorization: `Bearer ${$store.getters.token}` }
            }).then((response) => {
                commit('setReferrers', response.data)
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    getReferrerGroups({ commit, rootGetters }) {
        return new Promise((resolve, reject) => {
            axios.get('/api/referrers/get-referrer-groups', {
                headers: { Authorization: `Bearer ${$store.getters.token}` }
            })
            .then(response => {
                commit('setReferrerGroups', response.data);
                resolve(response);
            })
            .catch(error => {
                console.error('Error fetching referrer groups:', error); // Log errors
                reject(error);
            });
        });
    },
    deleteReferrer({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/referrers/${id}`, {
                headers: { Authorization: `Bearer ${$store.getters.token}` }
            }).then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    exportReferrers({ commit }, payload) {
        return new Promise((resolve, reject) => {
            commit('setExportingReferrers', true)
            axios.post('/api/referrers/export-referrers', payload, {
                headers: { Authorization: `Bearer ${$store.getters.token}` },
                responseType: 'blob'
            }).then((response) => {
                if (response) {
                    let filename = response.headers['content-disposition'].split('filename=')[1]
                    let fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
                    let fileLink = document.createElement('a')
                    fileLink.href = fileURL
                    fileLink.setAttribute('download', filename)
                    document.body.appendChild(fileLink)
                    fileLink.click()
                }
                this.$notify({
                    title: 'Success',
                    message: 'Referrers exported successfully',
                    type: 'success',
                })
                resolve(response)
            })
            .catch((error) => {
                this.$notify({
                    title: 'Error',
                    message: 'There was an error exporting referrers',
                    type: 'error',
                })
                reject(error)
            })
            .finally(() => {
                commit('setExportingReferrers', false)
            })
        })
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
